import axios from "axios";
import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import LoadingIndicator from "./components/LoadingIndicator/LoadingIndicator";
import "./NewTweetForm.css";

export default function NewTweetForm(props) {
  const { setTweets, isLoading, setIsLoading, userName } = props;
  const [text, setText] = useState("");
  const [serverError, setServerError] = useState("")

  const postTweet = async (newTweet) => {
    try {
      await axios.post(
        "https://micro-blogging-dot-full-stack-course-services.ew.r.appspot.com/tweet",
        newTweet
      );
      setTweets((prevTweets) => [newTweet, ...prevTweets]);
    } catch (err) {
      setServerError(JSON.stringify(err.message));
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddNote = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const newTweet = {
      userName: userName,
      content: text,
      date: new Date().toISOString("en-US"),
      id: uuid(),
    };
    postTweet(newTweet);
    setText("");
  };

  return (
    <>
    <form onSubmit={handleAddNote}>
      <textarea
        placeholder="What you have in mind..."
        value={text}
        onChange={(e) => setText(e.target.value)}
      ></textarea>
      <div className="bottom">
        {text.length > 140 && (
          <div className="err">
            The tweet can't contain more than 140 chars.
          </div>
        )}
        {/* <div className="words">{text.length} / 140</div> */}
        <button
          type="submit"
          disabled={isLoading || text.length > 140 || text.length === 0}
        >
          {isLoading ? <LoadingIndicator /> : "Tweet"}
        </button>
      </div>
    </form>
    {serverError !== "" && <div className="server-error">Server Error: {serverError}</div>}
    </>
  );
}
